import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-moon-rain': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M350.5 225.5c37.3 6.8 65.5 39.3 65.5 78.5 0 44.2-35.8 80-80 80h-256c-44.2 0-80-35.8-80-80 0-38.8 27.6-71.1 64.2-78.4 0-0.5-0.2-1.1-0.2-1.6 0-53 43-96 96-96 32.1 0 60.3 15.9 77.7 40 10.4-5 22-8 34.3-8 39.2 0 71.6 28.3 78.5 65.5zM567.9 223.8c6.2-1.2 10.6 6 6.4 10.8-27 33.1-67.9 53.3-112.6 53.3-5.2 0-10.1-1-15.2-1.5-6.2-39.4-33.1-72.5-70.2-86.8-10.7-27.9-32.2-49.8-58.9-61.7 3.3-76.7 66.5-137.9 144.4-137.9 8.9 0 17.8 0.8 26.5 2.4 6.2 1.1 7.6 9.4 2.1 12.5-35.6 20.1-57.5 57.5-57.5 98.1 0 70.5 64.6 124.1 135 110.8zM364.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6zM268.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6zM172.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6zM76.5 418.1c7.7 4.4 10.3 14.1 6 21.8l-36.6 64c-3 5.2-8.4 8.1-13.9 8.1-2.7 0-5.4-0.7-7.9-2.1-7.7-4.4-10.4-14.1-6-21.8l36.6-64c4.4-7.8 14.2-10.3 21.8-6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-moon-rain.js
// module id = 1210
// module chunks = 0